<template>
  <div :id="'animated-image-' + id"
       class="animated-image"
       :class="{
         'visible': visible
        }" v-if="id">
    <img :src="getImage(id)" :alt="id" class="animated-image-bg" />
  </div>
</template>
<script>
export default {
  name: 'AnimatedImage',
  props: ['id', 'visible'],
  methods: {
    getImage (id) {
      return require('@/assets/images/cekt/animated/' + id + '.png')
    }
  }
}
</script>

<style scoped lang="scss">
.animated-image {
  display: inline-block;
  position: relative;
  width: 100%;

  &-bg {
    height: auto;
    vertical-align: bottom;
    width: 100%;
    max-width: 100%;
  } // END .animated-image-bg;

} // END .animated-image;

#animated-image-phone {
  margin: 0 auto;
  max-width: 570px;

  &:after,
  &:before {
    background: {
      color: transparent;
      position: 0 0;
      repeat: no-repeat;
      size: 100%;
    }
    content: "";
    display: inline-block;
    position: absolute;
    transform-origin: center;
  }
  &:after {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 125 60'%3E%3Cpath fill='%23101820' d='M12.540,40.000 L125.000,40.000 L125.000,0.000 L0.000,0.000 L0.000,60.000 L12.540,40.000 Z'/%3E%3C/svg%3E");
    height: 10%;
    left: 35%;
    top: 21%;
    width: 22%;
  }
  &:before {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 114 83'%3E%3Cpath fill='%2396694c' d='M97.460,55.000 L0.000,55.000 L0.000,-0.000 L114.000,-0.000 L114.000,83.000 L97.460,55.000 Z'/%3E%3C/svg%3E");
    height: 14.5%;
    left: 53.5%;
    top: 15%;
    width: 20%;
  }

  &.visible {
    &:after,
    &:before {
      animation: shake ($animation-duration * 10) infinite ease-in-out;
    }
    &:after {
      animation-delay: ($animation-duration / 2);
    }
  }

} // END #animated-image-phone;

#animated-image-monalisa {

  &:after {
    @include after(57%, 0, 0 0 0 -100vw, 30.3%, 0, 10);
    background: $bg-accent;
    mix-blend-mode: multiply;
    padding-bottom: 7%;
    transition: all ($animation-duration * 2) ease-in;
    transition-delay: ($animation-duration / 2);
  }

  &.visible:after {
    width: 100vw;
  }
}
#animated-image-leonardo {
  &:after {
    @include after(0, 100%, 0, 0, 100%, 10);
    background: {
      image: url('data:image/gif;base64,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');
      position: 0 0;
      repeat: no-repeat;
      size: 100%;
    }
    mix-blend-mode: multiply;
    overflow: hidden;
    -webkit-backface-visibility: hidden;
  }

   &.visible:after {
    animation: glasses ($animation-duration * 3) steps(1) infinite;
  }
}
@keyframes glasses {
  from {
    background-position: 0 0;
  }
  50% {
    background-position: 0 100%;
  }
  to {
    background-position: 0 0;
  }
}

@keyframes shake {
  from, to { transform: translate3d(0, 0, 0) rotate(0); }
  10%, 30%, 50%, 70%, 90% { transform: translate3d(-4px, 0, 0) rotate(1deg); }
  20%, 40%, 60%, 80% { transform: translate3d(4px, 0, 0) rotate(-1deg); }
}
</style>
